module.exports = __webpack_public_path__ + "media/video01.c56c8348.mp4";